const tableHeaders = [
  {
    label: 'VIN',
    key: 'vin',
    defaultSort: true,
    sortable: false,
  },
  {
    label: 'Name',
    key: 'fullName',
    defaultSort: true,
    sortable: false,
  },
  {
    label: 'Email',
    key: 'email',
    defaultSort: true,
    sortable: false,
  },
  {
    label: 'Survey Type',
    key: 'surveyType',
    defaultSort: true,
    sortable: false,
  },
  {
    label: 'Survey Completion Date',
    key: 'surveyCompletionDate',
    defaultSort: true,
    sortable: false,
  },
  {
    label: 'SID',
    key: 'sid',
    defaultSort: true,
    sortable: false,
  },
  {
    label: 'Interference Method',
    key: 'interferenceMethod',
    defaultSort: true,
    sortable: false,
  },
  {
    label: 'Survey Outcome',
    key: 'surveyOutcome',
    defaultSort: true,
    sortable: false,
  },
  {
    label: 'Appeal',
    key: 'appealResult',
    defaultSort: true,
    sortable: false,
  },
  {
    label: 'Appeal Reason',
    key: 'appealReason',
    defaultSort: true,
    sortable: false,
  },
];

export default () => tableHeaders;
